<template>
  <div id="declareSon">
    <!-- <img src="../assets/Classroom/02.png">
    <div>
      <div class="title">中煤协科技创新项目通告</div>
      <div class="date">申报时间: 2019-10-02 ~ 2019-10-10</div>
      <div class="text"><span>申报要求: </span><div>依据：《科研项目经费管理办法》(校科字〔2017〕12号) :项目负责人暂离学校三个月以上，为保障项目持续进行，原则上
应由项目负责人提出经费使用委托申请，经二级单位、科研院审批后，在财务处办理相关手续。</div></div>
    </div>-->
    <div v-for="(item, index) in list" :key="index">
      <div class="title">{{ item.Title }}</div>
      <div class="date">申报时间: {{ item.Date }}</div>
      <div class="text">
        <span>申报要求:</span>
        <div>
          {{ item.Source }}
        </div>
      </div>
    </div>
    <!-- <el-pagination
      style="text-align: right;height: 0.45rem;z-index:1000;"
      v-if="list.length>0"
      @current-change="CurrentChange1"
      @size-change="handleSizeChange1"
      :current-page="Page1"
      :page-size="PageSize1"
      :page-sizes="[10, 20, 30]"
      layout="total,sizes, prev, pager, next, jumper"
      :total="total1"
    ></el-pagination> -->
  </div>
</template>
<script>
export default {
  name: "declareSon",
  data() {
    return {
      tota1: 0,
      list: [],
      Page1: 1,
      PageSize1: 10
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.post(`information/index?Type=5&page=${this.Page1}&num=${this.PageSize1}`).then(res => {
        console.log(res.data.data.list);
        this.list = res.data.data.list;
      });
    },
    CurrentChange1(val) {
      console.log(val)
      this.Page1 = val;
      this.getList();
    },
    handleSizeChange1(val) {
      console.log(val)
      this.PageSize1 = val;
      this.getList();
    },
  }
};
</script>
<style lang="less" scoped>
#declareSon {
  width: 100%;
  height: 1.35rem;
  display: flex;
  align-items: center;
  padding-bottom: 0.15rem;
  border-bottom: 0.01rem solid #e1e1e1;
  box-sizing: content-box;

  img {
    margin-right: 0.15rem;
    width: 2.5rem;
    height: 1.35rem;
  }

  >div {
    height: 1.35rem;
    width: 100%;
    display: flex;
    flex-direction: column;

    >div {
      margin-bottom: 0.2rem;
    }

    .title {
      font-size: 0.16rem;
      font-weight: bold;
    }

    .date,
    span {
      color: #4e4e4e;
      flex-shrink: 0;
      margin-right: 0.1rem;
    }

    .date,
    .text {
      display: flex;
      font-size: 0.15rem;
    }
  }
}</style>